// @ts-ignore
/* eslint-disable */

/**
 * API Module - All API requests are organized here
 * 
 * - login.ts: Authentication related APIs (login, logout, user info)
 * - mock.ts: Mock data APIs for development
 */

// HTTP Request Utility (re-exported from utils)
export { http, request, Result, RequestOptions } from '@/utils';

// Login & Auth APIs
export {
  getFakeCaptcha,
  login,
  currentUser,
  saveUserInfo,
  getUserInfo,
  clearUserInfo,
} from './login';

// Mock APIs
export {
  outLogin,
  getNotices,
  rule,
  updateRule,
  addRule,
  removeRule,
} from './mock';

// Account APIs
export {
  findAccount,
  addAccount,
  saveAccount,
  deleteAccount,
  getAccountDetail,
  saveMy,
} from './account';

// COS APIs
export {
  uploadToCOS,
  uploadMultipleToCOS,
  deleteFromCOS,
  checkFileExists,
  getSTSCredentials,
  initCOS,
  generateUniqueFileName,
} from './cos';
export type { UploadOptions, UploadResult, STSCredentials } from './cos';

// Contract APIs
export {
  listContract,
  addContract,
  saveContract,
  deleteContract,
  findContract,
  getContractDetail,
  listContractNode,
  addContractNode,
  saveContractNode,
  deleteContractNode,
  listContractPay,
  addContractPay,
  saveContractPay,
  deleteContractPay,
} from './contract';